export default __webpack_public_path__ + "static/media/payment-failure-dark.e6993af4.png";